import {axios as http} from "@/plugins/http"

export default class Api {
    static shopDetect(q) {
        return http.post("/api/v1/post/shop-detect", q);
    }
}
